export default "__VITE_ASSET__b0930f17__"